export default __webpack_public_path__ + "static/media/kanna.6420a381.png";